import { FC } from 'react';
import { Alert, AlertTitle, Box, Card } from '@material-ui/core';
import { ActivityLog } from 'src/interfaces/common/IdValue';
import PropTypes from 'prop-types';
import { ProfileStatus } from 'src/enums/common';

interface StatusDetailsProps {
  type?: string
  status: string,
  activityLogs: ActivityLog[]
}

export const StatusDetailsCard: FC<StatusDetailsProps> = (props) => {
  const { type, status, activityLogs } = props;

  return (
    <>
      {status === ProfileStatus.PENDING && (
      <Card
        variant="outlined"
        sx={{ mb: 1 }}
      >
        <Box>
          { type === 'Technician' ? (
            <Alert severity="warning">
              <AlertTitle>Profile is under review.</AlertTitle>
              The Technician application result will be sent
              you through email or notification.
            </Alert>
          )
            : (
              <Alert severity="warning">
                <AlertTitle>Profile is under review.</AlertTitle>
                The result of the Channel Partner application will be sent
                to the Channel Partner through email or notification.
              </Alert>
            )}
        </Box>
      </Card>
      )}
      {status === ProfileStatus.REJECTED && (
      <Card
        variant="outlined"
        sx={{ mb: 1 }}
      >
        <Box>
          <Alert severity="error">
            <AlertTitle>Rejected</AlertTitle>
            {activityLogs.length > 0 && activityLogs[0].remark}
          </Alert>
        </Box>
      </Card>
      )}
      {status === ProfileStatus.REVOKED && (
      <Card
        variant="outlined"
        sx={{ mb: 1 }}
      >
        <Box>
          <Alert severity="error">
            <AlertTitle>Revoked</AlertTitle>
            Revoked the invitation for this Channel Partner
          </Alert>
        </Box>
      </Card>
      )}
      {status === ProfileStatus.RESUBMIT && (
      <Card
        variant="outlined"
        sx={{ mb: 1 }}
      >
        <Box>
          <Alert severity="info">
            <AlertTitle>Resubmit Profile</AlertTitle>
            {activityLogs.length > 0 && activityLogs[0].remark}
          </Alert>
        </Box>
      </Card>
      )}

    </>
  );
};

StatusDetailsCard.propTypes = {
  // @ts-ignore
  type: PropTypes.string,
  status: PropTypes.string,
  activityLogs: PropTypes.array,
};
